/// <reference types="./publishedSampleEntities.d.ts" />
import { ok, } from '@dossierhq/core';
import { decodePublishedEntity } from '../EntityCodec.js';
import { sharedSampleEntities } from '../shared-entity/sharedSampleEntities.js';
export async function publishedSampleEntities(schema, publishedSchema, authorizationAdapter, databaseAdapter, context, query, options) {
    function getTotal(authKeys) {
        return databaseAdapter.publishedEntitySearchTotalCount(publishedSchema, context, query, authKeys);
    }
    async function sampleEntities(offset, limit, authKeys) {
        const sampleResult = await databaseAdapter.publishedEntitySampleEntities(publishedSchema, context, query, offset, limit, authKeys);
        if (sampleResult.isError())
            return sampleResult;
        const entities = sampleResult.value.map((it) => decodePublishedEntity(schema, it));
        return ok(entities);
    }
    return await sharedSampleEntities(authorizationAdapter, context, query, options, getTotal, sampleEntities);
}
//# sourceMappingURL=publishedSampleEntities.js.map